export function enumsFilter($rootScope) {
    "ngInject"
    return (value, name) => {
        if (!$rootScope.enums) {
            console.error('$rootScope.enums not find');
        }
        else {
            if (!$rootScope.enums[name]) {
                console.error(`can't find enums ${name} in $rootScope.enums`);
            }
            else {
                if (!$rootScope.enums[name][value]) {
                    console.error(`can't find value ${value} in enums ${name} in $rootScope.enums`);
                }
                else {
                    return $rootScope.enums[name][value];
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/filters/enums/enums.filter.ts